module.exports = __webpack_public_path__ + "img/McD_McDrive_Content_images_02.13c7b27b.jpg";